import EDHttp from '../utils/EDHttp';

export default
    {
        account: null,
        isAuthorized: function (permissions) {
            try {
                return this.account && this.account[permissions];
            }
            catch (error) {
                return false;
            }

        },
        requireAuthorization: function (permissions) {
            if (!this.isAuthorized(permissions)) {
                this.logout();
            }
        },
        logout: function () {
            return new Promise((resolve, reject) => {
                this.account = null;
                EDHttp.post('/auth/logout');
                localStorage.removeItem("ppjedp-mg-id");
                document.location.href = "/";
            })
        },
        async login(email, password) {
            try {
                const { data: result } = await EDHttp.post('/auth/login', {
                    email,
                    password,
                    type: "admin"
                });
                localStorage.setItem("ppjedp-mg-id", result.data.id);
                this.account = result.data
                return result.data;
            } catch (error) {
                throw error.response.data.message
            }
        },
        async authenticate() {
            try {
                const { data: result } = await EDHttp.get("/auth/user");
                this.account = result.data;
                return result.data;
            } catch (error) {
                localStorage.clear();
                throw false
            }
        },
        updatePassword: function (current, password) {
            return new Promise((resolve, reject) => {
                EDHttp.put("/auth/password", { current, password }).then(result => {
                    if (result.data.error)
                        reject(false);
                    else {
                        resolve(true);
                    }
                }, error => reject(false)).catch(error => reject(false));

            });
        },
        updateAccount: function (firstname, email, lastname, mi) {
            return new Promise((resolve, reject) => {
                EDHttp.put("/auth/profile", { firstname, email, lastname, mi }).then(result => {
                    if (result.data.error)
                        reject(false);
                    else {
                        this.account.name = `${firstname} ${lastname}`;
                        this.account.firstname = firstname;
                        this.account.lastname = lastname;
                        this.account.email = email.toLowerCase();
                        resolve(this.account);
                    }
                }, error => reject(false)).catch(error => reject(false));

            });
        },
        requestPasswordReset: function (email) {
            return new Promise((resolve, reject) => {
                EDHttp.post("/auth/reset", { email }).then(result => {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject("Unauthorized");
                }, error => {
                    reject(error)
                }).catch(error => reject(error));
            });
        },
        resetPassword: function (id, password, token) {
            return new Promise((resolve, reject) => {
                EDHttp.put("/auth/reset", { id, password, token }).then(result => {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                }, error => reject(error)).catch(error => reject(error));
            });
        }
    }